import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import EvaCardShell from '../EvaCardShell';
import EvaPasswordSignIn from '../EvaPasswordSignIn';
import EvaPhoneCodeSignIn from '../EvaPhoneCodeSignIn';
import EvaTabs from '../EvaTabs';

import styles from './index.module.scss';

const tabs = [
  { key: 'phone', labelKey: 'eva_domestic.phone_login' },
  { key: 'password', labelKey: 'eva_domestic.password_login' },
] as const;

type TabKey = (typeof tabs)[number]['key'];

/** EVA 登录卡:卡片外壳 + 「手机号登录 | 密码登录」双 tab。 */
const EvaSignInCard = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TabKey>('phone');

  return (
    <EvaCardShell variant="login">
      <EvaTabs
        className={styles.tabs}
        tabs={tabs.map(({ key, labelKey }) => ({ key, label: t(labelKey) }))}
        activeKey={activeTab}
        onChange={(key) => {
          // 经守卫收窄,无需断言
          if (key === 'phone' || key === 'password') {
            setActiveTab(key);
          }
        }}
      />
      <div className={styles.panel} role="tabpanel">
        {activeTab === 'phone' ? <EvaPhoneCodeSignIn isEmbedded /> : <EvaPasswordSignIn />}
      </div>
    </EvaCardShell>
  );
};

export default EvaSignInCard;
